import ControlHorari from "../../model/root/ControlHorari";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostUsiarisIdValidacio = async ( id : string , page : string, toast: any ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/usuaris/${id}/validar`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (response.ok) {
            toast.success("Actualitzat correctament")
        } else {
            toast.error(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
